<template>
  <div class="floating-wrapper-answers">
    <div class="dropdown">
      <span
        class="hoverit"
        v-if="matchedAnswer() === undefined"
        data-toggle="dropdown"
        >Add</span
      >
      <span v-else data-toggle="dropdown">
        {{ matchedAnswer().contact_type.name }}
      </span>
      <ul class="answers-dropdown-menu dropdown-menu">
        <li
          class="assign-menu-item"
          v-for="selectedMethodType in filterList()"
          :key="selectedMethodType.id"
          @click="sendInfo(selectedMethodType.id)"
        >
          {{ selectedMethodType.name }}
        </li>
      </ul>

      <!--            <div class="spinner-answer">-->
      <!--              <loader-->
      <!--                class="spinner-bottom-ms"-->
      <!--                v-if="showSpinner"-->
      <!--                :size="'3px'"-->
      <!--              ></loader>-->
      <!--            </div>-->
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Loader from "../../../../../../main/misc.main/loader/Loader";

import apiClientCreator from "../../../../../../helpers/api/request";

export default {
  name: "SelectComponent",
  props: {
    deposit: {
      type: Object,
      required: true
    },
    contacted: {
      type: Object,
      required: true
    },
    sendUpdated: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      choose: false,
      choosed: false
      // showSpinner: false,
    };
  },

  computed: {
    ...mapState("clients", ["dictionaries"])
  },

  methods: {
    filterList() {
      return this.dictionaries.activity.communication_types.filter(
        item => item.id !== 3
      );
    },
    matchedAnswer() {
      return this.contacted.find(
        answer => answer.deposit_id === this.deposit.id
      );
    },
    forChoose() {
      this.choose = true;
    },
    async sendInfo(id) {
      this.choose = false;
      this.choosed = true;

      await apiClientCreator(
        `client/support/deposit/answer/contacted_in/${this.deposit.id}`
      )
        .post("", { contact_type_id: id, client_id: this.deposit.client_id })
        .then(res => {
          this.$emit("updated");
        })
        .catch(err => {});
    }
  }
};
</script>

<style scoped>
.hoverit {
}
.hoverit:hover {
  background: #ffffff;
  cursor: pointer;
}

.assign-menu-item:hover {
  background: #e0e0e0;
  cursor: pointer;
}
.dropdown-menu:hover {
  background: #ffffff;
  cursor: pointer;
}
.dropdown:hover {
  background: #ffffff;
  cursor: pointer;
}

.answers-dropdown-menu {
  border-radius: 3px;
  left: -40px;
  position: absolute;
  padding: 5px;
  background-color: #fff;
  border: solid 1px #e4e8ea;
  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  font-family: Montserrat !important;
  font-size: 12px;
  text-align: center;
}
.answers-dropdown {
  width: max-content;
}
.answer {
  cursor: pointer;
}
.floating-wrapper-answers {
  position: relative;
}
/*spinner-answer {*/
/*    float: right;*/
/*    margin-top: 3px;*/
/*}*/
</style>
